function getFormattedGroupLabel (groupLabel) {

	switch (groupLabel) {

		case 'Motor Finish':
			return 'Finish';
		case 'Glass Color':
			return 'Color';
		default:
			return groupLabel;

	}

}

export default getFormattedGroupLabel;
